import cn from 'classnames';
import style from './ButtonBlack.module.scss';

function ButtonBlack({ className, handleFuction, text, type, testId }) {
  return (
    <button
      className={cn(style.buttonBlack, className)}
      onClick={handleFuction}
      type={!type ? 'button' : type}
      data-testid={testId}
    >
      <span>{text}</span>
    </button>
  );
}

export default ButtonBlack;
